import { colorMap } from '@/modules/pipelines/components/scroller/badges/pipeline-color-map';

export default function EventStatusBadge({ input }: { input?: string }) {
  return (
    <>
      {input && input !== 'unknown' && (
        <div className={`badge font-monospace ${colorMap[input]}`}>
          {input.at(0)?.toUpperCase() + input.slice(1)}
        </div>
      )}
    </>
  );
}
